<template>
    <div class="page info-edit">
        <!-- 头部 -->
        <head-bar title="编辑资料" :fixed="true">
            <template v-slot:right>
                <div class="head-right-slot">
                    <router-link to="/product/search">
                        <i class="head-search-icon"></i>
                    </router-link>
                    <router-link to="/">
                        <i class="head-home-icon"></i>
                    </router-link>
                </div>
            </template>
        </head-bar>
        <!-- 内容 -->
        <div class="content">
            <div class="info-status" v-if="$route.query.id">
                <p
                    v-if="form.state == invoiceStatusMap.auditSuccess"
                    class="status-ok-icon"
                >
                    审核通过
                </p>
                <p
                    v-if="form.state == invoiceStatusMap.auditRejected"
                    class="status-wrong-icon"
                >
                    审核失败（不影响您后续开票）
                </p>
                <p
                    v-if="form.state == invoiceStatusMap.awaitAudit"
                    class="status-wait-icon"
                >
                    待审核（不影响您后续开票）
                </p>
            </div>
            <div class="info-form">
                <div class="info-form-box">
                    <van-field
                        :disabled="isAuditSuccess"
                        label="*公司名称："
                        v-model="form.companyName"
                        placeholder="请输入公司名称"
                        maxlength="50"
                    >
                        <template #button>
                            <van-button
                                :disabled="isAuditSuccess"
                                hairline
                                size="mini"
                                type="primary"
                                @click="queryCompanyNameList"
                                >帮我匹配</van-button
                            >
                        </template>
                    </van-field>
                    <van-field
                        :disabled="isAuditSuccess"
                        label="*公司税号："
                        v-model="form.taxNo"
                        placeholder="请输入公司税号"
                        maxlength="20"
                    />
                    <van-field
                        label="注册地址："
                        v-model="form.registeredAddress"
                        type="textarea"
                        rows="1"
                        autosize
                        placeholder="请填写注册地址"
                        maxlength="100"
                    />
                    <van-field
                        label="公司电话："
                        v-model="form.companyTel"
                        type="tel"
                        placeholder="请输入公司电话"
                        maxlength="15"
                    />
                    <van-field
                        label="开户银行："
                        v-model="form.depositBank"
                        placeholder="请输入开户银行"
                        maxlength="100"
                    />
                    <van-field
                        label="银行账户："
                        v-model="form.bankAccount"
                        placeholder="请输入银行账号"
                        maxlength="50"
                    />
                    <div style="position: relative">
                        <van-field
                            :disabled="isAuditSuccess"
                            label="*开票方式："
                            :value="invoiceTypeAlias"
                            @click="openInvoiceTypePicker"
                            clickable
                            placeholder="请选择开票方式"
                            readonly
                        />
                        <i class="arrow-right-icon"></i>
                    </div>
                    <van-field
                        :disabled="isAuditSuccess && form.mail != ''"
                        label="*电子邮箱："
                        v-model="form.mail"
                        placeholder="请输入电子邮箱"
                        maxlength="72"
                    >
                        <template #button>
                            <van-button
                                :disabled="isAuditSuccess || isAddMailDisabled"
                                hairline
                                size="mini"
                                type="primary"
                                @click="addMailItem"
                                >新增</van-button
                            >
                        </template>
                    </van-field>
                    <van-field
                        v-show="mailShowMap.mail2"
                        :disabled="isAuditSuccess"
                        label="*备用邮箱："
                        v-model="form.mail2"
                        placeholder="请输入备用邮箱"
                        maxlength="72"
                    >
                        <template #button>
                            <van-button
                                :disabled="isAuditSuccess"
                                hairline
                                size="mini"
                                type="danger"
                                @click="() => deleteMailItem('mail2')"
                                >删除</van-button
                            >
                        </template>
                    </van-field>
                    <van-field
                        v-if="mailShowMap.mail3"
                        :disabled="isAuditSuccess"
                        label="*备用邮箱："
                        v-model="form.mail3"
                        placeholder="请输入备用邮箱"
                        maxlength="72"
                    >
                        <template #button>
                            <van-button
                                :disabled="isAuditSuccess"
                                hairline
                                size="mini"
                                type="danger"
                                @click="() => deleteMailItem('mail3')"
                                >删除</van-button
                            >
                        </template>
                    </van-field>
                </div>
                <!-- <div class="info-form-box">
                    <van-field
                        label="收票人："
                        v-model="form.receiver"
                        placeholder="请输入收票人"
                        maxlength="20"
                    />
                    <van-field
                        label="手机号码："
                        v-model="form.receiverPhone"
                        type="tel"
                        placeholder="请输入手机号码"
                        maxlength="11"
                    />
                    <div style="position: relative">
                        <van-field
                            label="收货地区："
                            :value="receivingArea"
                            @click="showAreaPicker = true"
                            clickable
                            placeholder="请选择收货地区"
                            readonly
                        />
                        <i class="arrow-right-icon"></i>
                    </div>
                    <van-field
                        label="详细地址："
                        v-model="form.detailAddress"
                        type="textarea"
                        rows="1"
                        autosize
                        placeholder="请填写详细地址"
                        maxlength="100"
                    />
                </div> -->
                <div :style="{ marginTop: '10px' }">
                    <van-cell
                        center
                        title="设为默认"
                        :title-style="{ fontSize: '12px' }"
                    >
                        <van-switch
                            v-model="form.isDefault"
                            active-color="#96EB7C"
                            inactive-color="#EDEDED"
                            slot="right-icon"
                            size="20"
                        />
                    </van-cell>
                </div>
                <div class="info-form-button">
                    <van-button
                        type="primary"
                        :loading="submitLoading"
                        loading-text="正在提交..."
                        @click="submitForm"
                        size="large"
                        round
                    >
                        提交审核
                    </van-button>
                </div>
                <div class="delete-button" v-if="deleteButtonVisible">
                    <van-button
                        color="#96EB7C"
                        type="primary"
                        :loading="submitLoading"
                        loading-text="正在删除..."
                        @click="handleDel"
                        size="large"
                        round
                    >
                        删除
                    </van-button>
                </div>
            </div>
        </div>

        <!-- 开票方式选择器 -->
        <my-popup v-model="showInvoiceTypePicker" title="开票方式">
            <ul class="invoice-type">
                <li
                    v-for="(item, index) in invoiceTypeOpts"
                    @click="confirmInvoiceType(item)"
                    :key="index"
                >
                    {{ item.label }}
                </li>
            </ul>
        </my-popup>

        <!-- 选择地区picker -->
        <!-- <area-picker
            v-model="showAreaPicker"
            :areaList="areaData"
            @change="areaChange"
        /> -->

        <van-action-sheet
            v-model="companyNameSheetVisble"
            :actions="companyNameList"
            @select="onCompanyNameSelect"
            cancel-text="取消"
        />
    </div>
</template>

<script>
import HeadBar from "@/components/HeadBar";
import AreaPicker from "@/components/AreaPicker";
import MyPopup from "@/components/MyPopup";
import { isPhone, isEmpty, isMail } from "@/utils/validation";
import Vue from "vue";
import { Field, Button, ActionSheet, Switch, Cell, Dialog } from "vant";
import utils from "../../../utils/utils";

Vue.use(Field);
Vue.use(Button);
Vue.use(ActionSheet);
Vue.use(Switch);
Vue.use(Cell);
Vue.use(Dialog);

export default {
    name: "InfoEdit",
    components: { HeadBar, AreaPicker, MyPopup, ActionSheet },
    data() {
        return {
            /* 路由参数 */
            query: {
                id: this.$route.query.id,
            },
            state: "", // 审核状态
            /* 表单数据 */
            form: {
                companyName: "", // 公司名称
                taxNo: "", // 公司税号
                registeredAddress: "", // 注册地址
                companyTel: "", // 公司电话
                depositBank: "", // 开户银行
                bankAccount: "", // 银行账号
                invoiceType: "", // 开票方式
                mail: "", //电子邮箱
                mail2: "",
                mail3: "",
                receiver: "", // 收票人
                receiverPhone: "", // 手机号码
                /* 省市区编码和名称 */
                provinceCode: "",
                provinceName: "",
                cityCode: "",
                cityName: "",
                countyCode: "",
                countyName: "",
                detailAddress: "", // 详细地址
                isDefault: false, //取消
                state: "",
            },
            /* 开票类型列表数据 */
            invoiceTypeOpts: [
                {
                    label: "按商品明细开",
                    value: 0,
                },
                {
                    label: "按商品大类开",
                    value: 1,
                },
            ],
            mailShowMap: {
                mail2: false,
                mail3: false,
            },
            //发票状态更改
            invoiceStatusMap: {
                awaitAudit: 1, //待审核
                auditSuccess: 2, //审核成功
                auditRejected: -1, //被驳回
            },
            showInvoiceTypePicker: false, // 开票类型弹窗
            showAreaPicker: false, // 收货地区弹窗
            submitLoading: false, // 提交审核loading
            areaData: [], // 地区数据(省市区插件)
            companyNameSheetVisble: false, //公司名称列表选项可见
            companyNameList: [], //公司名称列表
        };
    },
    computed: {
        /* 开票方式别名 */
        invoiceTypeAlias() {
            let alias = "";
            const arr = this.invoiceTypeOpts.filter((item) => {
                return this.form.invoiceType === item.value;
            });
            alias = arr.length > 0 ? arr[0].label : "";
            return alias;
        },
        /* 收货地区 */
        receivingArea() {
            const { provinceName, cityName, countyName } = this.form;
            const area = provinceName
                ? `${provinceName} ${cityName} ${countyName}`
                : "";
            return area;
        },
        deleteButtonVisible() {
            let { id } = this.query;
            return !isEmpty(id) && this.form.isDefault == false;
        },
        //是否可以添加备用邮箱
        isAddMailDisabled() {
            let { mail2, mail3 } = this.mailShowMap;
            return mail2 && mail3;
        },
        //是否审核成功
        isAuditSuccess() {
            if (this.form.state == this.invoiceStatusMap.auditSuccess) {
                return true;
            }
            return false;
        },
    },
    created() {
        let { id } = this.query;
        if (id) {
            this.getPageInfo();
        }
    },
    methods: {
        /* 获取页面信息 */
        getPageInfo() {
            const url = this.$api.userApi.queryInvoiceById;
            let { id } = this.query;
            let _this = this;
            const params = {
                context: {
                    invoiceId: id,
                },
            };
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            this.$axios
                .post(url, params)
                .then((res) => {
                    let { data: invocieInfo = {} } = res;
                    this.form = { ...invocieInfo };
                    // 构建参数(省市区插件展示需要)
                    let {
                        addressId,
                        bankAccount,
                        companyName,
                        companyTel,
                        creator,
                        depositBank,
                        detailAddress,
                        invoiceId = "",
                        invoiceType,
                        isDefault,
                        mailList = [],
                        receiver = "",
                        receiverPhone,
                        registeredAddress,
                        taxNo,
                        provinceCode,
                        provinceName,
                        cityCode,
                        cityName,
                        countyCode,
                        countyName,
                        state,
                    } = invocieInfo;
                    this.form = Object.assign(
                        { ...this.form },
                        {
                            addressId,
                            bankAccount,
                            companyName: companyName.trim(),
                            companyTel,
                            creator,
                            depositBank,
                            detailAddress,
                            invoiceId,
                            invoiceType,
                            isDefault,
                            receiver,
                            receiverPhone,
                            registeredAddress,
                            taxNo,
                            provinceCode: "",
                            provinceName: "",
                            cityCode: "",
                            cityName: "",
                            countyCode: "",
                            countyName: "",
                            state,
                        }
                    );
                    if (!isEmpty(mailList)) {
                        let mailKeysMap = {
                            "0": {
                                mailKeys: "mail",
                                showMail: false,
                            },
                            "1": {
                                mailKeys: "mail2",
                                showMail: true,
                            },
                            "2": {
                                mailKeys: "mail3",
                                showMail: true,
                            },
                        };
                        mailList.forEach((mail, index) => {
                            let { mailKeys, showMail } = mailKeysMap[index];
                            if (!isEmpty(mail)) {
                                _this.form[mailKeys] = mail;
                            }
                            if (showMail) {
                                this.mailShowMap[mailKeys] = true;
                            }
                        });
                    }
                    // if (
                    //     !isEmpty(provinceCode) &&
                    //     !isEmpty(cityCode) &&
                    //     isEmpty(countyCode)
                    // ) {
                    //     this.areaData = [
                    //         { areaCode: provinceCode, name: provinceName },
                    //         { areaCode: cityCode, name: cityName },
                    //         { areaCode: countyCode, name: countyName },
                    //     ];
                    // } else {
                    //     this.areaData = [];
                    // }
                })
                .finally(() => {
                    this.$toast.clear();
                });
        },
        /* 提交审核 */
        submitForm() {
            if (!this.validate()) return;
            this.invoiceOperate();
        },
        /* 创建 || 修改 发票信息 */
        invoiceOperate() {
            // 拦截状态
            const url = this.$api.userApi.invoiceApi;
            let _this = this;
            // 参数对象
            let mailKyes = ["mail", "mail2", "mail3"];
            let mailList = [];
            mailKyes.forEach((mailKye) => {
                let mail = _this.form[mailKye];
                if (!isEmpty(mail)) {
                    mailList.push(mail);
                }
            });
            let { companyName = "" } = this.form;
            let requestParams = Object.assign(
                { ..._this.form },
                { companyName: companyName.trim(), mailList: mailList }
            );
            const params = {
                operation: this.query.id ? "update" : "create",
                context: {
                    ...requestParams,
                },
            };

            this.submitLoading = true;
            this.$axios
                .post(url, params)
                .then((res) => {
                    this.$toast.success("提交成功");
                    this.$router.go(-1);
                })
                .catch((err) => {})
                .finally(() => {
                    this.submitLoading = false;
                });
        },
        /* 校验表单 */
        validate() {
            let {
                companyName,
                taxNo,
                registeredAddress,
                companyTel,
                depositBank,
                bankAccount,
                invoiceType,
                mail = "",
                mail2 = "",
                mail3 = "",
                receiver,
                receiverPhone,
                provinceCode,
                cityCode,
                countyCode,
                detailAddress,
            } = this.form;
            let { mail2: mail2Show, mail3: mail3Show } = this.mailShowMap;
            let mailLenth = 0;
            const mail_max_length = 72;
            mailLenth = mail.length + mail2.length + mail3.length;
            if (isEmpty(utils.trim(companyName))) {
                this.$toast("公司名称不能为空");
                return false;
            }
            if (isEmpty(utils.trim(taxNo))) {
                this.$toast("公司税号不能为空");
                return false;
            }
            // if (isEmpty(utils.trim(registeredAddress))) {
            //     this.$toast("注册地址不能为空");
            //     return false;
            // }
            // if (isEmpty(utils.trim(companyTel))) {
            //     this.$toast("公司电话不能为空");
            //     return false;
            // }
            // if (isEmpty(utils.trim(depositBank))) {
            //     this.$toast("开户银行不能为空");
            //     return false;
            // }
            // if (isEmpty(utils.trim(bankAccount))) {
            //     this.$toast("银行账号不能为空");
            //     return false;
            // }
            if (isEmpty(invoiceType)) {
                this.$toast("请选择开票方式");
                return false;
            }

            if (!isMail(mail)) {
                this.$toast("请填写正确的电子邮箱");
                return false;
            }

            if (mail2Show) {
                if (!isMail(mail2)) {
                    this.$toast("请填写正确的备用电子邮箱");
                    return false;
                }
            }

            if (mail3Show) {
                if (!isMail(mail3)) {
                    this.$toast("请填写正确的备用电子邮箱");
                    return false;
                }
            }

            if (mailLenth > mail_max_length) {
                let msg = `所有邮箱总长度加起来不超过${mail_max_length}字符`;
                this.$toast(msg);
            }

            // if (!isEmpty(provinceCode)) {
            //     // if (isEmpty(utils.trim(receiver))) {
            //     //     this.$toast("收票人不能为空");
            //     //     return false;
            //     // }
            //     // if (!isPhone(receiverPhone)) {
            //     //     this.$toast("手机号码格式不正确");
            //     //     return false;
            //     // }
            //     if (isEmpty(cityCode)) {
            //         this.$toast("请在收货地区中选择城市");
            //         return false;
            //     }
            //     if (isEmpty(isEmpty)) {
            //         this.$toast("请在收货地区中选择区域");
            //         return false;
            //     }
            // }
            // if (!provinceCode) {
            //     this.$toast("请选择收货地区");
            //     return false;
            // }
            // if (isEmpty(utils.trim(detailAddress))) {
            //     this.$toast("详细地址不能为空");
            //     return false;
            // }
            return true;
        },
        /* 确认开票类型 */
        confirmInvoiceType(data) {
            this.form.invoiceType = data.value;
            this.showInvoiceTypePicker = false;
        },
        /* 地区改变事件 */
        areaChange(data) {
            if (!isEmpty(data)) {
                // 表单赋值
                this.form.provinceCode = data[0].areaCode;
                this.form.provinceName = data[0].name;
                this.form.cityCode = data[1].areaCode;
                this.form.cityName = data[1].name;
                this.form.countyCode = data[2].areaCode;
                this.form.countyName = data[2].name;
            } else {
                // 表单赋值
                this.form.provinceCode = "";
                this.form.provinceName = "";
                this.form.cityCode = "";
                this.form.cityName = "";
                this.form.countyCode = "";
                this.form.countyName = "";
            }
        },
        /** 查找公司名称 */
        queryCompanyNameList() {
            const { companyName } = this.form;
            if (this.isAuditSuccess) return;
            if (isEmpty(utils.trim(companyName))) {
                this.$toast("公司名称不能为空");
                return false;
            }
            const url = this.$api.commonApi.queryCompanyNameList;
            const params = {
                context: {
                    companyName: companyName,
                },
            };
            this.submitLoading = true;
            this.$toast.loading({
                message: "数据匹配中...",
                duration: 0,
            });
            this.$axios
                .post(url, params)
                .then((res) => {
                    let { data: companyNameList = [] } = res;
                    this.companyNameList = companyNameList;
                    this.companyNameSheetVisble = true;
                })
                .finally(() => {
                    this.submitLoading = false;
                    this.$toast.clear();
                });
        },
        /**
         * 选取公司
         */
        onCompanyNameSelect(item) {
            let { name } = item;
            if (!name) return;
            const url = this.$api.commonApi.queryCompanyInfo;
            const params = {
                context: {
                    companyName: name,
                },
            };
            this.$axios
                .post(url, params)
                .then((res) => {
                    let { data: companyInfo = {} } = res;
                    let {
                        address = "",
                        bank = "",
                        bankAccount = "",
                        creditCode = "",
                        name = "",
                        tel = "",
                    } = companyInfo;
                    this.form.companyName = name;
                    this.form.taxNo = creditCode;
                    this.form.registeredAddress = address;
                    this.form.companyTel = tel;
                    this.form.depositBank = bank;
                    this.form.bankAccount = bankAccount;
                })
                .finally(() => {
                    this.companyNameSheetVisble = false;
                });
        },
        /* 删除 */
        handleDel() {
            Dialog.confirm({
                title: "提示",
                message: "是否确认删除?",
                confirmBUttonColor: "#4BC227",
            })
                .then(() => {
                    this.submitLoading = false;
                    const url = this.$api.userApi.invoiceApi;
                    const params = {
                        operation: "delete",
                        context: {
                            invoiceId: this.query.id,
                        },
                    };

                    this.delLoading = true;
                    this.$axios
                        .post(url, params)
                        .then((res) => {
                            this.$toast.success("删除成功");
                            this.$router.go(-1);
                        })
                        .finally(() => {
                            this.submitLoading = false;
                        });
                })
                .catch(() => {});
        },
        openInvoiceTypePicker() {
            if (this.isAuditSuccess) return;
            this.showInvoiceTypePicker = true;
        },
        deleteMailItem(key) {
            if (this.isAuditSuccess) return;
            let { mail2, mail3 } = this.mailShowMap;
            if (key == "mail3" && mail3) {
                key = "mail3";
                if (isEmpty(this.form.mail2)) {
                    this.form.mail2 = this.form.mail3;
                }
            }
            this.form[key] = "";
            this.mailShowMap[key] = false;
        },
        addMailItem() {
            if (this.isAuditSuccess) return;
            let { mail2, mail3 } = this.mailShowMap;
            let keys = "mail2";
            if (mail2) {
                keys = "mail3";
            }
            this.form[keys] = "";
            this.mailShowMap[keys] = true;
        },
    },
};
</script>

<style lang="less" scoped>
.info-edit {
    .head-right-slot {
        height: 100%;
        text-align: right;
        padding-right: 20px;

        i {
            display: inline-block;
            width: 60px;
            height: 100%;
            background-repeat: no-repeat;
            background-size: 48px;
            background-position: center;
            margin: 0 10px;

            &.head-search-icon {
                background-image: url(../../../public/images/head/head-search-icon.png);
            }

            &.head-home-icon {
                background-image: url(../../../public/images/head/head-home-icon.png);
            }
        }
    }

    .content {
        padding-top: 20px;

        .info-status {
            background: #fff;
            height: 88px;
            line-height: 88px;
            padding: 0 30px;

            p {
                font-size: 24px;
                padding-left: 50px;
                background-repeat: no-repeat;
                background-size: 40px;
                background-position: left;

                &.status-ok-icon {
                    background-image: url(../../../public/images/user/invoice/status-ok-icon.png);
                }

                &.status-wrong-icon {
                    background-image: url(../../../public/images/user/invoice/status-wrong-icon.png);
                }

                &.status-wait-icon {
                    background-image: url(../../../public/images/user/invoice/status-wait-icon.png);
                }
            }
        }

        .info-form {
            margin-top: 20px;

            .info-form-box {
                margin-top: 20px;

                .van-cell {
                    font-size: 24px;

                    /deep/ .van-field__label {
                        width: 150px;
                    }
                }

                .arrow-right-icon {
                    position: absolute;
                    top: 50%;
                    right: 30px;
                    width: 40px;
                    height: 40px;
                    transform: translateY(-50%);
                    background: url(../../../public/images/common/arrow-right-icon.png)
                        center no-repeat;
                    background-size: 100%;
                }
            }

            .info-form-button {
                padding: 40px 30px 20px;
            }

            .delete-button {
                padding: 0px 30px 80px;
            }
        }
    }

    .invoice-type {
        padding: 0 30px;

        li {
            font-size: 28px;
            height: 116px;
            line-height: 116px;
            text-align: center;
            border-bottom: 1px solid #f2f2f2;

            &:first-child {
                border-top: 1px solid #f2f2f2;
            }
        }
    }
}
</style>
